export interface AvailabilitySlot {
  id: string;
  from: string; // ISO DateTime
  to: string; // ISO DateTime
  scope: string;
  facilities: string[];
}
